import * as React from 'react';
import { formattedDate } from '../../../common/helpers/date';
import { useTranslations } from '../../../common/translation';
import { HeadTitle } from '../../../components/head-title/HeadTitle';
import { categoryList } from '../common';
import { useInitializeNews } from '../hooks/useInitializeNews';
import { NewsProps } from '../NewsLayout.props';
import { StyledNews, StyledNewsContent, StyledNewsDate, StyledNewsHeader, StyledNewsTitle } from '../NewsLayout.styles';
import translations from '../translations';

export const PressRelease = ({ body, categories, date, timezone, title }: NewsProps) => {
  const { locale, t } = useTranslations(translations);
  const localeDate = typeof date !== 'undefined' ? formattedDate(date, locale, 'default', timezone) : '';

  useInitializeNews();

  return (
    <StyledNews data-component='press-release'>
      <HeadTitle title={`${title} | ${t('pressReleasePageTitle', 'Press Releases')}`} />
      <StyledNewsHeader>
        {categoryList(categories, t)}
        {localeDate && <StyledNewsDate data-testid='news-date'>{localeDate}</StyledNewsDate>}
        <StyledNewsTitle>{title}</StyledNewsTitle>
      </StyledNewsHeader>
      <StyledNewsContent>
        <div dangerouslySetInnerHTML={{ __html: body }} />
      </StyledNewsContent>
    </StyledNews>
  );
};
